import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { LoginService } from '../../../../../../libs/utils/auth-shared/src/lib/services/login.service';
import { NotificationService } from '../../../../../../libs/utils/ng-shared-components/src';
import { INotificationTrayService } from '../../../../../../libs/utils/ng-shared-components/src/lib/notification-tray/INotificationTray';
import { ModalService } from '../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { CustomFormBuilder } from '../../../../../../libs/utils/ng-shared-components/src/lib/validation/form-builder/custom-form-builder';
import { GUID_EMPTY } from '../../../../../../libs/utils/ts-shared/src/lib/utils-guid';
import { OperationDto, OperationDtoFormGroup } from '../../../api/dtos/OperationDto';
import { ApiClientAdminConfiguration } from '../../../api/endpoints/ApiClientAdminConfiguration';
import { ApiClientAdminOperation } from '../../../api/endpoints/ApiClientAdminOperation';
import { Currency } from '../../../api/enums/Currency';
import { OperationStatus } from '../../../api/enums/OperationStatus';
import { Roles } from '../../../api/enums/Roles';
import { enumName_mi_pspc } from '../../../api/enums/_enumName.mi_pspc';
import { OperationService } from './operation.service';
import { ApiClientAdminClient } from '../../../api/endpoints/ApiClientAdminClient';
import { OrderStatus } from '../../../api/enums/OrderStatus';

@Component({
  standalone: false,
  selector: 'mf-operation',
  templateUrl: './operation.component.html',
  styleUrls: ['./operation.component.scss'],
})
export class OperationComponent implements OnInit {
  constructor(
    private _cfb: CustomFormBuilder,
    private _modalService: ModalService,
    private _operationService: OperationService,
    private _apiClientAdminOperation: ApiClientAdminOperation,
    private _notificationService: NotificationService,
    private _apiClientAdminConfiguration: ApiClientAdminConfiguration,
    private _loginService: LoginService,
    private _apiClientAdminClient: ApiClientAdminClient,
    @Inject('INotificationTrayService') public notificationTrayService: INotificationTrayService
  ) {
    this.setClient();
    this.operationDto = this._operationService.operationDto;
  }

  ngOnInit(): void {
    this._operationService.updatedOperationDto.subscribe((operationDto: OperationDto) => {
      this.operationDto = operationDto;
    });
    this.loadCurrencyList();
  }

  operationDto: OperationDto;
  @Input() isEditing = false;

  @Output()
  save = new EventEmitter<OperationDto>();
  @Output()
  executeOperation = new EventEmitter<OperationDto>();
  @Output()
  backToDraft = new EventEmitter<OperationDto>();

  currencyList: Currency[];
  operationStatus = OperationStatus;
  isSuperAdmin = false;
  clientName: string;

  operationForm = this._cfb.group<OperationDtoFormGroup>({
    id: [GUID_EMPTY],
    clientId: [null, null],
    client: [null, Validators.required, 'Cliente'],
    currency: [null, Validators.required, 'Moneda'],
    reason: [null, Validators.required, 'Motivo de la operación'],
  });

  enumName = enumName_mi_pspc;

  public get disableButton() {
    if (!this.isEditing || (this.isEditing && this.operationDto.status < OperationStatus.Completed)) {
      return false;
    }
    return true;
  }

  public get textButton() {
    if (!this.isEditing) {
      return 'Crear borrador';
    } else if (this.isEditing && this.operationDto.status == OperationStatus.Draft) {
      return 'Confirmar operación';
    }
    return 'Editar';
  }

  closeModal() {
    this._modalService.closeAsSuccess();
  }

  async updateAllowPayments() {
    this._modalService.openYesOrNoModal({
      openData: {
        title: 'Si habilitas los pagos, ya no podrás agregar o editar más ordenes ¿Esta seguro?',
      },
      onCloseSuccess: async () => {
        await this._apiClientAdminOperation.closeOperationToNewOrders(this.operationDto.id);
        this._operationService.reloadOperation(this.operationDto.id);
      },
    });
  }

  async editOperation() {
    if (this.operationDto.status == OperationStatus.Draft) {
      this._modalService.openYesOrNoModal({
        openData: {
          title: 'Confirmar operación',
          message: 'Al confirmar, los pagos quedan habilitados para ejecutarse una vez confirmados los cobros. ¿Está seguro?',
        },
        onCloseSuccess: async () => {
          this.executeOperation.emit(this.operationDto);
        },
      });
    } else {
      this._modalService.openYesOrNoModal({
        openData: {
          title: 'Permitir editar la operación, ¿Esta seguro?',
        },
        onCloseSuccess: async () => {
          this.backToDraft.emit(this.operationDto);
        },
      });
    }
  }

  async updateOperation() {
    await this._apiClientAdminOperation.updateDraftOrders(this.operationDto.id);
    this._notificationService.showSuccess('Operación actualizada');
    this._operationService.reloadOperation(this.operationDto.id);
  }

  async loadCurrencyList() {
    this.currencyList = await this._apiClientAdminConfiguration.getCurrencyList();
  }

  async setClient() {
    this.isSuperAdmin = this._loginService.userIsInRole([Roles[Roles.SuperAdmin]]);

    if (!this.isSuperAdmin) {
      this.clientName = this._loginService.loggedClientName;
      this.operationForm.patchValue({
        clientId: this._loginService.loggedClientId,
        client: await this._apiClientAdminClient.getCurrentClient(),
      });
    }
  }

  getCollectOrderAmount() {
    return this.operationDto.collectOrders.filter((c) => c.status != OrderStatus.Cancelled).reduce((acc, order) => acc + order.amount, 0);
  }

  getPaymentOrderAmount() {
    return this.operationDto.paymentOrders.filter((c) => c.status != OrderStatus.Cancelled).reduce((acc, order) => acc + order.amount, 0);
  }
}
